import { render } from "./CompanyDocument.vue?vue&type=template&id=76dc5ce7&scoped=true"
import script from "./CompanyDocument.vue?vue&type=script&lang=js"
export * from "./CompanyDocument.vue?vue&type=script&lang=js"

import "./CompanyDocument.vue?vue&type=style&index=0&id=76dc5ce7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76dc5ce7"]])

export default __exports__